module.exports = __webpack_public_path__ + "static/img/l_mnt.09f2f79d.png";